import { FoodStockRepository } from '../repositories/FoodStockRepository'

export function DeleteFoodStockItemCase(
  foodStockRepository: FoodStockRepository
) {
  return async function (foodStockId: string) {
    return await foodStockRepository.deleteFoodStockItem(foodStockId)
  }
}
